import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
import Orders from "../../../order/orders/orders.jsx";
import Shop_info from "./shop/shop_info.jsx";
import Shop_edit from "./shop/shop_edit.jsx";
import Shop_pay from "./shop/shop_pay.jsx";
import Api_info from "./api/api_info.jsx";
import Api_edit from "./api/api_edit.jsx";
import Options from '../../../shop/ai/options.jsx';
import Lists from "./services/lists.jsx";
import Api_docs from "../../orders/api_docs.jsx";
const Account_home = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();
    useEffect(() => {
        thongtintk();
    }, []);
    useEffect(() => {

    }, [slug_2]);

    function thongtintk() {
        // setnutxuly(0);
        const domain = window.location.hostname;
        const apikey = Cookies.get('apikey');
        axios
            .get('https://hust.media/api/orders/account/sellers/shop/check.php?apikey=' + apikey)
            .then(response => testFunction(response))
            .catch(error => alert_error(error))
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 1) {
            alert_success(message);
        }
        else {
            alert_error('đã xảy ra lỗi vui lòng liên hệ admin')
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                switch_router(info.redirect);
            }, 1700);
        }
    };
    return (
        <>
            {(slug_2 === 'settings' && slug_3 === 'home') && (<><Shop_info category_main='shop' /></>)}
            {(slug_2 === 'settings' && slug_3 === 'edit') && (<><Shop_edit /></>)}
            {(slug_3 === 'orders' && slug_4 === 'local') && (<>
                <><Lists category_main='accounts_seller' /></>
            </>)}
            {(slug_3 === 'orders' && slug_4 === 'api') && (<>
                <><Lists category_main='accounts_seller' /></>
            </>)}
            {(slug_3 === 'services' && slug_4 === 'lists') && (<><Lists category_main='accounts_services' /></>)}
            {(slug_3 === 'services' && slug_4 === 'orders') && (<><Orders category_main='accounts_services' /></>)}
            {slug_2 === 'home' && (<><Options /></>)}
            {(slug_2 === 'shop' && slug_3 === 'home') && (<><Options /></>)}
            {(slug_2 === 'history' && slug_3 === 'home') && (<><Options /></>)}
            {(slug_1 === 'sellers' && slug_2 === 'api' && slug_4 === 'orders') && (<><Api_docs category="accounts_seller_api" /></>)}
            {(slug_1 === 'sellers' && slug_2 === 'api' && slug_4 === 'history') && (<><Api_docs category="accounts_seller_history" /></>)}

            {(slug_2 === 'api' && slug_3 === 'lists') && (<><Api_info /></>)}
            {(slug_2 === 'api' && slug_3 === 'settings') && (<><Api_edit /></>)}
            {(slug_2 === 'history' && slug_3 === 'orders') && (<><Lists category_main='accounts_orders' /></>)}
            {(slug_2 === 'history' && slug_3 === 'lists') && (<><Shop_pay /></>)}

        </>
    );
};

export default Account_home;
